import { render, staticRenderFns } from "./process-trace.vue?vue&type=template&id=0c5ad1c1&scoped=true"
import script from "./process-trace.vue?vue&type=script&lang=js"
export * from "./process-trace.vue?vue&type=script&lang=js"
import style0 from "./process-trace.vue?vue&type=style&index=0&id=0c5ad1c1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5ad1c1",
  null
  
)

export default component.exports